class Instrument {
    constructor() {
        this.info = {};
    }

    getInfo() {
        return this.info;
    }
}

export { Instrument };